  
    import { Component, Mixins, Ref } from "vue-property-decorator";
    import ETable from "@/components/ETable.vue";
    import RichText from "@/components/rich-text.vue";
  
    import TablePagination from "@/mixins/tablePagination";
    import Resize from "@/mixins/resize";

    import { tongueProfileEdit, tongueProfileList } from "@/api/tongue";
    import { ElForm } from "element-ui/types/form";

    import { cloneDeep } from "lodash";

    import { formatTextarea } from "@/utils/common"

    const rangeValidator = (name) => {
      return (rule, value, callback) => {
        const { min, max } = value || {}

        if (min === undefined || max === undefined) {
          return callback(new Error(`${name}分值区间不能为空`))
        }

        if (min > max) {
          return callback(new Error(`${name}最小值不能大于最大值`))
        }

        if (min < 0 || max > 100) {
          return callback(new Error(`${name}分值需在 0-100 之间`))
        }

        callback()
      }
    }
  
    @Component({ name: 'tongue-components-symptom',
      components: {
        ETable,
        RichText
      }
    })
    export default class TongueExplain extends Mixins(Resize, TablePagination) {
      @Ref("formRef") formRef !: ElForm;
      @Ref("scoreFormRef") scoreFormRef !: ElForm;
  
      toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [{'header': [1, 2, 3, 4, 5, 6, false]}],
        [{'color': []}], // dropdown with defaults from theme
        [{'align': []}],
        [{'clean': '清除'}], // remove formatting button
        ['image']
      ]

      tableData: Array<any> = [];
      tableLoading = false;
      columns = [
        { label: "舌诊症状", prop: "tongueSymptomName" },
        { label: "症状解释（通用性别）", prop: "symptomExplanationT" },
        { label: "对应五脏", prop: "", formatter: (row) => row.visceras.reduce((acc, cur) => acc + cur.visceraName + "、", "").slice(0, -1) },
        { label: "建议（通用性别）", prop: "suggestion" },
        { label: "症状（通用性别）", prop: "symptomInfo" },
        { label: "原因（通用性别）", prop: "reason" },
        { label: "预防疾病（通用性别）", prop: "preventDisease" },
        { label: "四诊调养数量", prop: "", formatter: (row) => row.fdmConsultationCount || 0 },
        { label: "操作人", prop: "modifiedBy" },
        { label: "最后操作时间", prop: "modifiedTime" },
        { label: "操作", prop: "action"},
    ]
  
      dialogVisible = false;
      healthDialogVisible = false;
      maintenanceDialogVisible = false;

      scoreDialogVisible = false;
      dialogForm = {
        id: "",
        tongueSymptomName: "", // 症状名称
        preventDisease: "", // 预防疾病
        reason: "", // 原因
        suggestion: "", // 原因
        symptomDetail: "", // 症状秒速
        symptomInfo: "", // 症状
        symptomInfoM: "",
        reasonM: "",
        preventDiseaseM: "",
        symptomInfoW: "",
        reasonW: "",
        preventDiseaseW: "",
        minoritySymptomInfo: "",
        minorityReason: "",
        minorityPreventDisease: "",
        suggestionM: "",
        suggestionW: "",
        minoritySuggestion: "",
        symptomDetailM: "",
        symptomDetailW: "",
        minoritySymptomDetail: "",
        homeHealth: "",
        homeHealthM: "",
        homeHealthW: "",
        homeHealthT: "",
        maintenanceRecommendations: "",
        maintenanceRecommendationsM: "",
        maintenanceRecommendationsW: "",
        maintenanceRecommendationsT: "",
        symptomExplanationT: "",
        symptomExplanationM: "",
        symptomExplanationW: "",
        symptomExplanation: "",
      };

      scoreForm = {
        buwei: "", // 部位
        pi: { min: 0, max: 100 }, // 脾
        fei: { min: 0, max: 100 }, // 肺
        shen: { min: 0, max: 100 }, // 肾
        gan: { min: 0, max: 100 }, // 肝
        xin: { min: 0, max: 100 }, // 心
      }

      scoreFormRules = 
        {
          pi: [
            { required: true, validator: rangeValidator('脾'), trigger: 'blur' }
          ],
          fei: [
            { required: true, validator: rangeValidator('肺'), trigger: 'blur' }
          ],
          shen: [
            { required: true, validator: rangeValidator('肾'), trigger: 'blur' }
          ],
          gan: [
            { required: true, validator: rangeValidator('肝'), trigger: 'blur' }
          ],
          xin: [
            { required: true, validator: rangeValidator('心'), trigger: 'blur' }
          ]
        }


      activeName = "first";
  
      mounted() {
        this.windowResize(220);
        this.getData();
      }

      formatTextarea(content) {
        return formatTextarea(content)
      }
  
      getData() {
        tongueProfileList({}).then((res) => {
          this.tableData = res.data;
          console.log(res);
        })
      }

      // 编辑
      edit(row, type) {
        if(type == 'edit') this.dialogVisible = true;
        if(type == 'homeHealth') this.healthDialogVisible = true;
        if(type == 'maintenanceRecommendations') this.maintenanceDialogVisible = true;
        
        const {
          id,
          ...otherInfo
        } = row;
        Object.assign(this.dialogForm, { id, ...otherInfo });

        if (type == 'score') {
          this.scoreForm.buwei = row.visceras.reduce((acc, cur) => acc + cur.visceraName + "、", "").slice(0, -1);
          this.setScoreForm(row);
          this.scoreDialogVisible = true;
        }
      }

      setScoreForm(form) {
        const { heartScoreMin, heartScoreMax, kidneysScoreMin, kidneysScoreMax, liverScoreMin, liverScoreMax, lungsScoreMin, lungsScoreMax, spleenScoreMin, spleenScoreMax } = form;
        this.scoreForm = {
          ...this.scoreForm,
          xin: { min: heartScoreMin, max: heartScoreMax },
          shen: { min: kidneysScoreMin, max: kidneysScoreMax },
          gan: { min: liverScoreMin, max: liverScoreMax },
          fei: { min: lungsScoreMin, max: lungsScoreMax },
          pi: { min: spleenScoreMin, max: spleenScoreMax }
        }
      }

      scoreSave() {
        this.scoreFormRef.validate().then(() => {
          console.log(this.scoreForm);
          const params = {
            ...this.dialogForm,
            heartScoreMin: this.scoreForm.xin.min,
            heartScoreMax: this.scoreForm.xin.max,
            kidneysScoreMin: this.scoreForm.shen.min,
            kidneysScoreMax: this.scoreForm.shen.max,
            liverScoreMin: this.scoreForm.gan.min,
            liverScoreMax: this.scoreForm.gan.max,
            lungsScoreMin: this.scoreForm.fei.min,
            lungsScoreMax: this.scoreForm.fei.max,
            spleenScoreMin: this.scoreForm.pi.min,
            spleenScoreMax: this.scoreForm.pi.max
          }
          tongueProfileEdit(params).then(() => {
            this.$message.success("操作成功");
            this.scoreCancel();
            this.getData();
          })
        })
      }

      scoreCancel() {
        this.scoreHandleClose();
      }

      save() {
        const params = cloneDeep(this.dialogForm);
        tongueProfileEdit(params).then(() => {
          this.$message.success("操作成功");
          this.cancel();
          this.getData();
        })
      }

      cancel() {
        this.handleClose();
      }
  
      handleClose() {
        this.dialogForm.id = "";
        this.formRef?.resetFields();
        this.dialogVisible = false;
        this.healthDialogVisible = false;
        this.maintenanceDialogVisible = false;
        this.activeName = "first";
      }

      scoreHandleClose() {
        this.scoreDialogVisible = false;
        this.scoreFormRef?.resetFields();
        this.scoreForm = {
          buwei: "", // 部位
          pi: { min: 0, max: 100 }, // 脾
          fei: { min: 0, max: 100 }, // 肺
          shen: { min: 0, max: 100 }, // 肾
          gan: { min: 0, max: 100 }, // 肝
          xin: { min: 0, max: 100 }, // 心
        }
      }
  
    }
  